/**
 * Display pieces shared by the three editorial ability screens (abd-*).
 *
 * One export, on purpose: this file exists because the hero title's grammar was
 * standing in three files byte for byte, not as a lobby for everything abd-*.
 * A piece earns a place here by being worn by more than one screen.
 */

import { ReactNode } from "react";

/** The hero title wears its last word in italic, the house display grammar.
 *  The class is a required parameter: every caller (Masthead, the account
 *  passport name) rides its own size, so there is no one default to fall
 *  back to. */
export function HeroTitle({
  name,
  className,
}: {
  name: string | ReactNode;
  className: string;
}) {
  if (typeof name !== "string") return name;

  const cut = name.lastIndexOf(" ");
  const lead = cut === -1 ? "" : name.slice(0, cut + 1);
  const accent = cut === -1 ? name : name.slice(cut + 1);
  return (
    <h1 className={className}>
      {lead}
      <em>{accent}</em>
    </h1>
  );
}
